import { render } from "./UserEditHeader.vue?vue&type=template&id=65bbca8e"
import script from "./UserEditHeader.vue?vue&type=script&lang=js"
export * from "./UserEditHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__